import { FC, useEffect } from "react";
import {
  Wrapper,
  ProfielWapper,
  DropdownContainer,
  DropdownOption,
  ProfileImage,
  ActiveUsers,
  RefreshIcon,
  RefreshSection,
} from "./StyledAppTopBar";
import ProfileImageSrc from "../../assets/images/profileavtar.webp";

import * as localStorageActionType from "../../LocalStorage/ActionTypes";
import { setLocalStorage } from "../../LocalStorage/SetLocalStorage";

import { adminRouts } from "../../routs";
import { useNavigate } from "react-router-dom";

import { RootState } from "../../app/Store";
import { useSelector, useDispatch } from "react-redux";
import { Without2faLogin, getActiveUserCount } from "../../features/loginSlice";
import useDimension from "../../costomHook/useDimention";
import * as UIConstants from "../../UIConstants";

const AppTopBar: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dimention = useDimension();

  const activeUserCount = useSelector(
    (state: RootState) => state.login.activeUserCount
  );

  useEffect(()=>{
    dispatch(getActiveUserCount());

  },[activeUserCount])

  const clearLocalStorage = () => {
    setLocalStorage(localStorageActionType.CLEAR_LOGIN_USER_DETAIL, "");
    navigate(adminRouts.login);
   
  };

  const redirectToProfile = () => {
    navigate(adminRouts.profile);
  };

  const updatedActiveUserCount = () => {
    dispatch(getActiveUserCount());
  };

  return (
    <Wrapper>
      {/* {dimention.width >= UIConstants.mobileWidth ? (
        <> */}
          <ActiveUsers>
            Active Users&nbsp;:&nbsp;<span>{activeUserCount}</span>
          </ActiveUsers>
          <RefreshSection onClick={updatedActiveUserCount}>
            <RefreshIcon />
          </RefreshSection>
        {/* </>
      ) : (
        ""
      )} */}
      <ProfielWapper>
        <ProfileImage src={ProfileImageSrc} />
        <DropdownContainer>
          <DropdownOption onClick={clearLocalStorage}>Logout</DropdownOption>
          {/* <DropdownOption onClick={redirectToProfile}>Profile</DropdownOption> */}
        </DropdownContainer>
      </ProfielWapper>
    </Wrapper>
  );
};

export default AppTopBar;
